/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: LoggingSettingsPage.tsx
 🗓️ Created: 2025-01-20
 🧩 Description:
    Main logging settings page - redirects to form since this is a single configuration.

 🔁 Last Updated: 2025-01-20 by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../../hooks/useI18n';
import { useNavigationStore } from '../../store/navigation';

export function LoggingSettingsPage() {
  const { t, refreshKey } = useI18n();
  const navigate = useNavigate();
  const { setCurrentPageTitle } = useNavigationStore();
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    setCurrentPageTitle(null);
    return () => setCurrentPageTitle(null);
  }, [setCurrentPageTitle]);

  useEffect(() => {
    // Redirect directly to form (single configuration) - only once
    if (!hasRedirectedRef.current) {
      hasRedirectedRef.current = true;
      navigate('/settings/pbx/log-files/edit', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-muted-foreground">Loading...</div>
    </div>
  );
}

